export default "__VITE_ASSET__BYBcDbhP__"